import React from 'react';
import SubjectPage from '../structure/SubjectPage';

const CN_AI = ({ branch = "AIML", semester = "4th Semester" }) => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Introduction to Layered Network Architecture- What are computer networks, Layered
        models for networking, different types of communication models, ISO-OSI Model, TCP/IP. </p>
    </div>,
    <div key="2" className="p-4">
      <p>Data Link Protocols- Stop and Wait protocols, Noise-free and Noisy Channels,
        Performance and Efficiency, Sliding Window protocols, MAC Sublayer: The Channel
        Allocation Problem, Carrier Sense Multiple Access Protocols, Collision Free Protocols,
        FDDI protocol. IEEE Standard 802.3 & 802. 11 for LANs and WLANs</p>
    </div>,
    <div key="3" className="p-4">
      <p>Network Layer protocols- Design Issues: Virtual Circuits and Datagrams, Routing
        Algorithms, Optimality principle, shortest path routing Algorithms, Flooding and
        Broadcasting, Distance Vector Routing, Link State Routing, Flow-Based Routing, Multicast
        Routing; Flow and Congestion Control. </p>
    </div>,
    <div key="4" className="p-4">
      <p>Transport Layer Protocols- Design Issues, Quality of Services. The Internet Transport
        Protocols. IPV4 vs IPV6. Session Layer protocol: Dialog Management, Synchronization,
        Connection Establishment. Quality of service, security management, Firewalls. Application
        layer protocols: HTTP, SMTP, FTP, SNMP, etc. </p>
    </div>
  ];

  const tabData = [
    { id: 'syllabus', label: 'Syllabus', content: null },
    { id: 'notes', label: 'Notes', content: null },
    { id: 'important', label: 'Important Questions', content: null },
    { id: 'books', label: 'Books', content: null },
    { id: 'PYQ', label: 'PYQ', content: null },
    { id: 'youtube_playlist', label: 'Video Lectures', content: null },
  ];

  return (
    <SubjectPage
      subjectName="Computer Networks and Internet Protocols"
      subjectKey="AI_CN"
      branch={branch}
      semester={semester}
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'AI_CNNotes',
        videos: 'AI_CNVideos'
      }}
    />
  );
};

export default CN_AI;